var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    [
      _c(
        "v-dialog",
        {
          attrs: { lazy: "", "max-width": "500" },
          on: {
            input: function(v) {
              return v
            }
          },
          model: {
            value: _vm.showUpdateDialog,
            callback: function($$v) {
              _vm.showUpdateDialog = $$v
            },
            expression: "showUpdateDialog"
          }
        },
        [
          _c(
            "v-card",
            { staticClass: "pa-4" },
            [
              _c(
                "v-layout",
                { attrs: { column: "" } },
                [
                  _c("span", { staticClass: "title mb-3" }, [
                    _vm._v(
                      "\n          Update Load's Settlement Details\n        "
                    )
                  ]),
                  _vm._v(" "),
                  _vm.currentUserCanModifySettlementAmount
                    ? _c("v-text-field", {
                        attrs: { label: "Amount" },
                        model: {
                          value: _vm.updatedAmount,
                          callback: function($$v) {
                            _vm.updatedAmount = $$v
                          },
                          expression: "updatedAmount"
                        }
                      })
                    : [
                        _c(
                          "span",
                          { staticClass: "font-weight-light font-italic" },
                          [
                            _vm._v("\n            The load\n            "),
                            _vm.settlement.customerCompany
                              ? _c("span", [_vm._v("dispatcher")])
                              : _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm
                                        .$t(
                                          "components.load-details.self-contracted"
                                        )
                                        .toLocaleLowerCase()
                                    )
                                  )
                                ]),
                            _vm._v(
                              "\n            can modify the settlement amount.\n          "
                            )
                          ]
                        )
                      ],
                  _vm._v(" "),
                  _vm.currentItemDelivered &&
                  _vm.currentUserCanModifySettlementDeliveryDetails
                    ? [
                        _c("v-text-field", {
                          attrs: { label: _vm.billOfLadingNumberFieldLabel },
                          model: {
                            value: _vm.updatedBOL,
                            callback: function($$v) {
                              _vm.updatedBOL = $$v
                            },
                            expression: "updatedBOL"
                          }
                        }),
                        _vm._v(" "),
                        _c("v-text-field", {
                          attrs: { label: "Head count" },
                          model: {
                            value: _vm.updatedHeadCount,
                            callback: function($$v) {
                              _vm.updatedHeadCount = $$v
                            },
                            expression: "updatedHeadCount"
                          }
                        })
                      ]
                    : [
                        _c(
                          "span",
                          { staticClass: "font-weight-light font-italic" },
                          [
                            _vm._v(
                              "\n            Once a load is delivered, " +
                                _vm._s(_vm.$t("terms.bill-of-lading")) +
                                " number and final animal count can be\n            corrected by the carrier if necessary.\n          "
                            )
                          ]
                        )
                      ],
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "accent", loading: _vm.loadingBtn },
                          on: {
                            click: function($event) {
                              return _vm.saveUpdate()
                            }
                          }
                        },
                        [_vm._v("\n            Save\n          ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "accent", flat: "" },
                          on: {
                            click: function($event) {
                              _vm.showUpdateDialog = false
                            }
                          }
                        },
                        [_vm._v("\n            Cancel\n          ")]
                      )
                    ],
                    1
                  )
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-btn",
        {
          staticClass: "ma-0",
          attrs: {
            color: _vm.color,
            fab: _vm.fab,
            small: _vm.small,
            disabled: !!_vm.disabled
          },
          on: { click: _vm.openUpdateDialog }
        },
        [
          _vm._t("default", function() {
            return [_vm._v("\n      Update Details\n    ")]
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-27a4e51a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27a4e51a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settlement/UpdateSettlementDetails.vue
// module id = null
// module chunks = 